export default __webpack_public_path__ + "f0b3de56c23556debacd770ee9fa5a11.png";